export const calculateHour = {
  methods: {
    calculateHour(min) {
      let hour = parseInt(min / 60)
      let minuts = min - hour * 60
      return `${hour}:${minuts}`
    },
  },
}
